import type { ReactNode } from "react";

/**
 * O cabeçalho de página, em quatro partes — e um só, para todas as telas.
 *
 * Antes cada tela montava o seu: umas tinham `<h1>` e mais nada, outras um
 * "‹ Início" acima do título, outras um parágrafo de apoio que corria a tela
 * inteira em 1920px. Três telas dizendo a mesma coisa de três formas é o que
 * faz o app parecer montado por partes.
 *
 * As quatro partes são fixas:
 *
 *   eyebrow    caixa alta, 12px, tinta secundária — a seção ou o contexto
 *   título     Newsreader, o nome da tela
 *   subtítulo  **uma** frase, com medida máxima de 70ch
 *   ações      o canto direito, para o botão primário da tela
 *
 * O subtítulo é uma frase e não um parágrafo por decisão de texto, não de
 * layout: ele diz o que a pessoa faz ali, nunca como o sistema funciona.
 */
export function CabecalhoDePagina({
  eyebrow,
  titulo,
  subtitulo,
  acoes,
  children,
  id,
}: {
  eyebrow?: ReactNode;
  titulo: ReactNode;
  subtitulo?: ReactNode;
  acoes?: ReactNode;
  /** Abas ou filtros presos abaixo do título, quando a tela tem. */
  children?: ReactNode;
  id?: string;
}) {
  return (
    <header className="cabecalho-pagina">
      <div className="cabecalho-pagina__linha">
        <div className="cabecalho-pagina__texto">
          {eyebrow && <p className="etiqueta">{eyebrow}</p>}
          <h1 className="titulo-tela" id={id}>
            {titulo}
          </h1>
          {subtitulo && <p className="secundario medida-texto">{subtitulo}</p>}
        </div>
        {acoes && <div className="cabecalho-pagina__acoes">{acoes}</div>}
      </div>
      {children}
    </header>
  );
}
